import React, { Component } from 'react';
import './Invoices.css';
import { connect } from 'react-redux';
import { invoices, downloadSummary } from '../../services/invoices';
import { DatePicker, Icon, Button } from 'element-react';
import FileSaver from 'file-saver';
import { getBookingGuests, queryDownloadInvoice, queryDownloadInvoicePresent } from '../../services/guests';

class Invoices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      invoices: [],
      appliedFilters: [],
      checkInDate: new Date(new Date().getFullYear(), new Date().getMonth() - 3, new Date().getDate()),
      checkOutDate: new Date()
    };
  }

  async componentDidMount() {
    this.loadBooking();
  }

  async loadBooking() {
    const { data } = await invoices(this.state.checkInDate, this.state.checkOutDate);
    this.setState({ invoices: data, loading: false });
  }

  async updateFilters(dateIn, dateOut) {
    this.setState({ loading: true });

    const { data } = await invoices(dateIn, dateOut);
    this.setState({ invoices: data, loading: false });
  }

  checkInDateSelect(date) {
    this.setState({ checkInDate: date });
    this.updateFilters(date, this.state.checkOutDate);
  }

  checkOutDateSelect(date) {
    this.setState({ checkOutDate: date });
    this.updateFilters(this.state.checkInDate, date);
  }

  async downloadInvoice(booking, type) {
    try {
      let response = type === 'booking'
        ? await queryDownloadInvoice(booking._id)
        : await queryDownloadInvoicePresent(booking._id);

      const file = new Blob([response.data], { type: 'application/pdf' });
      FileSaver.saveAs(file, `factura_${'A-' + ('000000' + booking.invoiceId).slice(-6)}.pdf`);
      this.setState({ downloading: false });
    } catch (err) {
      console.error(err);
      this.setState({ downloading: false });
      alert('Se ha producido un error, refresca la pagina y vuelve a intentarlo.');
    }
  }

  async downloadSumUp() {
    const response = await downloadSummary(this.state.checkInDate, this.state.checkOutDate);
    const file = new Blob([response.data], { type: 'application/pdf' });
    FileSaver.saveAs(file, `resumen_facturas.pdf`);
  }

  renderFilters() {
    return (
      <div className="bookingsFilters">
        <div className="bookingsFilter">
          <p>Inicio periodo:</p>
          <DatePicker
            firstDayOfWeek="1"
            format="dd-MM-yyyy"
            value={this.state.checkInDate}
            placeholder="Escoge dia"
            onChange={date => this.checkInDateSelect(date)}
          />
        </div>
        <div className="bookingsFilter">
          <p>Final periodo:</p>
          <DatePicker
            firstDayOfWeek="1"
            format="dd-MM-yyyy"
            value={this.state.checkOutDate}
            placeholder="Escoge dia"
            onChange={date => this.checkOutDateSelect(date)}
          />
        </div>
      </div>
    );
  }

  renderBooking = (invoice) => (
    <div className="baseCard">
      <h4>Reserva #{invoice.bookingId}</h4>
      <div className="action">
        <h5>{new Date(invoice.createdAt).toLocaleDateString()}</h5>
        <h5>{'A-' + ('000000' + invoice.invoiceId).slice(-6)}</h5>
        <Button onClick={() => this.downloadInvoice(invoice, 'booking')}>Descargar</Button>
      </div>
    </div>
  );

  renderRegal = (invoice) => (
    <div className="baseCard">
      <h4>Regala #{invoice.presentId}</h4>
      <div className="action">
        <h5>{new Date(invoice.createdAt).toLocaleDateString()}</h5>
        <h5>{'A-' + ('000000' + (invoice.invoiceId || invoice.lastInvoiceId)).slice(-6)}</h5>
        <Button onClick={() => this.downloadInvoice(invoice, 'present')}>Descargar</Button>
      </div>

    </div>
  );

  renderInoices() {
    return (
      <div className="invoicesList">
        <div className="invoicesList-Header">
          <p>Total facturas: {this.state.invoices.length}</p>
          <div>
            <Button onClick={() => this.downloadSumUp()}>Descargar resumen</Button>
            <p>Total facturado: {this.state.invoices.reduce((acc, cur) => {
              if (cur.presentId) return acc + cur.total; // regalas canjeados convertidos en bookings
              return acc + (cur.bookingId ? cur.totalPaid : cur.total);
            }, 0)} €</p>
          </div>
        </div>

        {this.state.invoices.map((invoice, index) =>
          <div>
            {
              invoice.bookingId && !invoice.presentId
                ? this.renderBooking(invoice)
                : this.renderRegal(invoice)
            }
          </div>
        )}
      </div>
    )
  }

  render() {
    return (
      <div className="invoicesWrapper">
        {this.renderFilters()}

        <h3>Libro de facturas</h3>
        <p>Disclaimer:
          <br></br>
          1) Sólo aparecen facturas completamente formadas (reservas: identificador, regalas: indentificador)
          <br></br>
          2) Filtrar por período de facturación
          <br></br>
          3) Esta lista es read & download only
        </p>

        {
          this.state.loading
            ? <Icon name={'loading'} style={{ padding: 8 }} />
            : this.renderInoices()
        }

      </div>
    );
  }
}

const mapStateToProps = state => ({ rooms: state.rooms });

export default connect(mapStateToProps)(Invoices);



// WEBPACK FOOTER //
// ./src/components/Invoices/Invoices.jsx